import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import ZiggsLogo from "@/components/Logo";

export const Footer = () => (
    <footer className="border-t border-forge-line bg-forge-ink">
        <div className="zf-container grid gap-12 py-16 md:grid-cols-3 md:py-20">
            <div>
                <div className="zf-logo flex items-center gap-3">
                    <ZiggsLogo className="h-12 w-12" />
                    <span className="font-display text-base font-bold uppercase text-forge-paper">
                        Ziggs<span className="text-forge-yellow">Forge</span>
                    </span>
                </div>
                <p className="mt-4 max-w-xs text-sm leading-relaxed text-forge-dim">
                    Estúdio de impressão 3D. Ideias forjadas camada por camada, do arquivo digital ao objeto real.
                </p>
            </div>

            <div className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.2em]">
                <span className="text-forge-yellow">Navegue</span>
                {[
                    { to: "/", label: "Início" },
                    { to: "/catalogo", label: "Catálogo" },
                    { to: "/contato", label: "Contato" },
                ].map((l) => (
                    <Link key={l.to} to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-forge-dim transition-colors hover:text-forge-yellow">
                        {l.label}
                    </Link>
                ))}
            </div>

            <div className="flex flex-col gap-3">
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-forge-yellow">Fale com a forja</span>
                <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=ziggsforge@gmail.com&su=Contato%20pelo%20site%20%E2%80%94%20Ziggs%20Forge&body=Ol%C3%A1!%20Vi%20o%20site%20da%20Ziggs%20Forge%20e%20quero%20falar%20sobre%20um%20projeto."
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-email-link"
                    className="inline-flex items-center gap-2 text-sm text-forge-dim transition-colors hover:text-forge-paper"
                >
                    <Mail className="h-4 w-4 text-forge-yellow" />
                    ziggsforge@gmail.com
                </a>
                <a href="tel:+5522999989203" data-testid="footer-phone-link" className="inline-flex items-center gap-2 text-sm text-forge-dim transition-colors hover:text-forge-paper">
                    <Phone className="h-4 w-4 text-forge-yellow" />
                    +55 (22) 99998-9203
                </a>
            </div>
        </div>

        <div className="border-t border-forge-line">
            <div className="zf-container flex flex-col items-start justify-between gap-2 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-forge-dim md:flex-row md:items-center">
                <span>© {new Date().getFullYear()} Ziggs Forge</span>
                <span className="flex items-center gap-2">
                    Feito camada por camada
                    <span className="inline-block h-1.5 w-1.5 rotate-45 bg-forge-yellow" />
                </span>
            </div>
        </div>
    </footer>
);

export default Footer;
